<div class="tam-btn-loading" *ngIf="tamLoading">
    <i class="tam-loading"></i>
</div>
<span #contentElement><ng-content></ng-content></span>